import { ColumnConfig } from '../hooks/useTablePreferences';

export const patientNotificationColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 220,
    minWidth: 160,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'entity',
    label: 'Entity',
    defaultWidth: 140,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'emailTemplate',
    label: 'Email Template',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'smsTemplate',
    label: 'SMS Template',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'schedule',
    label: 'Schedule',
    defaultWidth: 200,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'isActive',
    label: 'Active',
    defaultWidth: 90,
    minWidth: 70,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'sendReminders',
    label: 'Reminders',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'reminderCount',
    label: 'Reminder Count',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'daysBetween',
    label: 'Days Between',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'includeCriteria',
    label: 'Include Criteria',
    defaultWidth: 160,
    minWidth: 130,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'excludeCriteria',
    label: 'Exclude Criteria',
    defaultWidth: 160,
    minWidth: 130,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
];
